import { MedicalPaOrderStatus } from "../enums/medicalPaOrderStatus";

export const STATUS_LOG_CONFIG = {
  [MedicalPaOrderStatus.PENDING]: {
    followUpTypes: [
      {
        label: "Waiting for payer response",
        value: "waiting_for_payer_response",
      },
      {
        label: "Additional information requested by payer",
        value: "additional_info_requested_by_payer",
      },
      {
        label: "Additional information submitted",
        value: "additional_info_submitted",
      },
      {
        label: "Eligibility discrepancy identified",
        value: "eligibility_discrepancy_identified",
      },
      {
        label: "Waiting for clinical documents",
        value: "waiting_for_clinical_documents",
      },
      {
        label: "Duplicate or system issue identified",
        value: "duplicate_or_system_issue_identified",
      },
    ],
    templates: [
      "Called the payer. The case is currently under review; no additional information is required at this time.",
      "Payer requested additional information, which has been submitted/faxed.",
      "Payer communicated a potential denial; the case has been withdrawn.",
      "Eligibility discrepancy has been identified and the case is under review.",
      "Authorization not required per payer policy.",
      "Unable to proceed due to portal access issue; follow-up required",
    ],
  },

  [MedicalPaOrderStatus.QUERY]: {
    followUpTypes: [
      {
        label: "Query follow-up checked in OncoEMR",
        value: "query_followup_checked_oncoemr",
      },
    ],
    templates: [
      "NCCN covered Dx Code still not added.",
      "Drug is non-preferred & is still not updated.",
      "Clinical Documents are not updated, remains missing.",
      "Query yet to be resolved.",
      "Primary Insurance not updated, remains Inactive.",
    ],
  },

  others: {
    followUpTypes: [
      {
        label: "Added notes",
        value: "notes",
      },
    ],
    templates: [],
  },
} as const;

export const getStatusLogConfig = (status: string) => {
  const { followUpTypes, templates } = STATUS_LOG_CONFIG[status] ?? {
    followUpTypes: [],
    templates: [],
  };

  return { followUpTypes, templates };
};
